import { MUTATION_TYPES } from './types';

const mutations = {
  setResult(state, payload) {
    state.result = payload;
  },
  setPagination(state, payload) {
    state.pagination = payload;
  },
  setFilter(state, payload) {
    state.filter = payload;
  },
  setActionType(state, { id, actionType }) {
    state.results = {
      ...state.results,
      data: state.results.data.map((item) => {
        if (item.requestServiceId === id) {
          item.actionType = actionType;
        }
        return item;
      }),
    };
  },
  setCurrentFilters(state, payload) {
    state.currentFilters = payload;
  },

  [MUTATION_TYPES.SET_ACADEMICYEARS](state, payload) {
    state.filters.academicyears = payload;
  },

  [MUTATION_TYPES.SET_SERVICESTATUS](state, payload) {
    state.filters.servicestatus = payload;
  },

  [MUTATION_TYPES.SET_SERVICETYPES](state, payload) {
    state.filters.servicetype = payload;
  },

  [MUTATION_TYPES.SET_RESULTS_FILTERED](state, payload) {
    state.results = payload;
    state.tableConfig.totalRecords = payload.totalItemCount;
  },

  [MUTATION_TYPES.SET_REASONS](state, payload) {
    state.reasons[payload.id] = payload.reasons;
  },
};

export default mutations;
